const SHOP_DOMAIN = 'fincoracoffee.com';

// NAV scroll
const navbar = document.getElementById('navbar');
if (navbar) {
  window.addEventListener('scroll', () => { navbar.classList.toggle('scrolled', window.scrollY > 60); });
}

// Scroll animations
const observer = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.12 });
document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

// Product state (still used for the homepage weight-selector UI)
const products = {
  p1: { weight:'250g', price:9.50,  variant:'62535203029322' },
  p2: { weight:'250g', price:8.95,  variant:'62535204962634' },
  p3: { weight:'250g', price:8.50,  variant:'62535216136522' },
};

function selectWeight(btn, pid, weight, price, variant) {
  btn.closest('.weight-selector').querySelectorAll('.weight-opt').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  products[pid] = { weight, price, variant };
  document.getElementById('price-' + pid).textContent = '£' + price.toFixed(2);
}

// ---------- REAL SHOPIFY CART (single source of truth) ----------

function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}

function addToCart(name, pid) {
  const p = products[pid];
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: p.variant, quantity: 1 })
  })
    .then(res => res.json())
    .then(() => refreshCartUI())
    .then(() => openCart())
    .catch(err => console.error('Add to cart failed:', err));
}

function interceptProductForms() {
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(res => res.json())
        .then(() => refreshCartUI())
        .then(() => openCart())
        .catch(err => console.error('Add to cart failed:', err));
    });
  });
}

function changeQty(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  })
    .then(res => res.json())
    .then(() => refreshCartUI())
    .catch(err => console.error('Update cart failed:', err));
}

function removeFromCart(key) {
  changeQty(key, 0);
}

function refreshCartUI() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => renderCart(cart));
}

// Safe helper: only touch an element if it actually exists on this page
function setText(id, text) {
  const el = document.getElementById(id);
  if (el) el.textContent = text;
}
function setDisplay(id, value) {
  const el = document.getElementById(id);
  if (el) el.style.display = value;
}
function setHref(id, href) {
  const el = document.getElementById(id);
  if (el) el.href = href;
}

function renderCart(cart) {
  setText('cart-total', formatMoney(cart.total_price));

  const badge = document.getElementById('cart-badge');
  if (badge) {
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
  }

  setHref('checkout-btn', '/checkout');

  const itemsEl = document.getElementById('cart-items');
  const emptyEl = document.getElementById('cart-empty');
  if (!itemsEl || !emptyEl) return; // drawer not present on this page at all

  itemsEl.querySelectorAll('.cart-item').forEach(el => el.remove());

  if (cart.items.length === 0) {
    emptyEl.style.display = 'flex';
    return;
  }
  emptyEl.style.display = 'none';

  cart.items.forEach((item) => {
    const div = document.createElement('div');
    div.className = 'cart-item';
    div.innerHTML = `
      <div style="width:56px;height:56px;background:var(--charcoal);display:flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;">
        ${item.image
          ? `<img src="${item.image}" style="width:100%;height:100%;object-fit:cover;">`
          : `<svg width="20" height="20" fill="none" stroke="var(--gold)" stroke-width="1" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>`
        }
      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-variant">${item.variant_title || ''}</div>
        <div class="cart-qty-row">
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">−</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
          <button class="cart-remove" onclick="removeFromCart('${item.key}')">Remove</button>
        </div>
      </div>
      <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>`;
    itemsEl.insertBefore(div, emptyEl);
  });
}

function openCart() {
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  if (!overlay || !drawer) return;
  overlay.classList.add('open');
  drawer.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  const overlay = document.getElementById('cart-overlay');
  const drawer = document.getElementById('cart-drawer');
  if (!overlay || !drawer) return;
  overlay.classList.remove('open');
  drawer.classList.remove('open');
  document.body.style.overflow = '';
}

function handleSubmit(e) {
  e.preventDefault();
  document.getElementById('form-success').style.display = 'block';
}

document.addEventListener('DOMContentLoaded', function () {
  refreshCartUI();
  interceptProductForms();
});